'use es6';

import EmbedIframe from 'rich-text-lib/components/embed/EmbedIframe';
import { HS_EMBED_INNER_WRAPPER_CLASS } from '../../../constants/hsMedia';
import { getResponsiveEmbedInnerWrapperStyles, ResponsiveEmbedIframeStyles } from '../../../hsmedia/util';

// Component representation of the cross-origin iframe
// embed plus wrapper
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function StaticIframeEmbed(props) {
  const {
    inpage,
    embedId
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: HS_EMBED_INNER_WRAPPER_CLASS,
    style: getResponsiveEmbedInnerWrapperStyles({
      asAttr: true
    }),
    children: [/*#__PURE__*/_jsx(EmbedIframe, {
      inpage: inpage,
      embedId: embedId,
      style: ResponsiveEmbedIframeStyles
    }), /*#__PURE__*/_jsx("span", {
      className: "mce-shim"
    })]
  });
}